import React, { useEffect, useState } from "react";
import { Card, Col } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { useTranslation } from "react-i18next";


const HotelList = ({ title, data = [] }) => {
  const { t } = useTranslation();
  const columns = [
    {
      head: t("dashboard.columns.hotel"),
      accessor: "hotelName",
      component: (item) => (
        <>{item?.hotelDetail?.hotelName ? item?.hotelDetail?.hotelName : "-"}</>
      ),
    },
    {
      head: t("dashboard.columns.location"),
      accessor: "hotelId",
      component: (item) => (
        <>{item.hotelDetail?.address ? item.hotelDetail?.address : "-"}</>
      ),
    },
    {
      head: t("dashboard.columns.booking"),
      accessor: "label",
      component: (item) => <>{item?.bookingCount ? item?.bookingCount : "-"}</>,
    },
    {
      head: t("dashboard.columns.price"),
      accessor: "totalRoom",
      component: (item) => (
        <>{item?.hotelDetail?.price ? item?.hotelDetail?.price : "-"}</>
      ),
    },
  ];

  return (
    <div className="cardCstm p-3 border rounded">

      <h6 className="fw-bold text-dark mb-3">{title}</h6>
      <Col lg="12" className="my-2">
        <TableLayout column={columns} data={data} />
      </Col>
    </div>
  );
};

export default HotelList;
